import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class GasActivationTestDto extends InspectionCase {
  containerPosition?: InspectionValueCase;
  containerIsAccessible?: InspectionCase;
  containerLocation?: InspectionCase;
  solonoidModel?: InspectionCase;
  gasTypeAndWeight?: InspectionCase;
  pipingDiameterAndType?: InspectionCase;
  detectorDetails?: InspectionValueCase;
  crosstab?: InspectionCase;
  shutdownButton?: InspectionCase;
  sealing?: InspectionCase;
  powerOutages?: InspectionValueCase;
  pressureClockIndicatesGreen?: InspectionCase;
  soloenoidConnected?: InspectionCase;
}

export class GasActivationTest extends GasActivationTestDto {
  constructor(data: GasActivationTestDto = { title: 'בדיקת הפעלה' }) {
    super(data);
    this.containerPosition = new InspectionValueCase({
      ...data.containerPosition,
      title: `המיכל תלוי / עומד / שוכב`
    });
    this.containerIsAccessible = new InspectionCase({
      ...data.containerIsAccessible,
      title: `המיכל נגיש להפעלה ידנית`
    });
    this.containerLocation = new InspectionCase({
      ...data.containerLocation,
      title: `מיקום מיכל הכיבוי`
    });
    this.solonoidModel = new InspectionCase({
      ...data.solonoidModel,
      title: `דגם הסולונואיד`
    });
    this.gasTypeAndWeight = new InspectionCase({
      ...data.gasTypeAndWeight,
      title: `סוג הגז ומשקלו`
    });
    this.pipingDiameterAndType = new InspectionCase({
      ...data.pipingDiameterAndType,
      title: `סוג הצנרת והקוטר שלו`
    });
    this.detectorDetails = new InspectionValueCase({
      ...data.detectorDetails,
      title: `הפעלת הגלאי/ם`
    });
    this.crosstab = new InspectionCase({
      ...data.crosstab,
      title: `הצלבה / ללא הצלבה`
    });
    this.shutdownButton = new InspectionCase({
      ...data.shutdownButton,
      title: `הפעלת לחצן כיבוי / מכני חובה`
    });
    this.sealing = new InspectionCase({
      ...data.sealing,
      title: `איטומים`
    });
    this.powerOutages = new InspectionValueCase({
      ...data.powerOutages,
      title: `ניתוקי חשמל`
    });
    this.pressureClockIndicatesGreen = new InspectionCase({
      ...data.pressureClockIndicatesGreen,
      title: `שעון הלחץ מורה על ירוק ומופנה לכיוון המשתמש`
    });
    this.soloenoidConnected = new InspectionCase({
      ...data.soloenoidConnected,
      title: `בסוף הבדיקה יש לחבר את הסולונואיד / נפץ למיכל הכיבוי`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.containerPosition.isApplicable ||
        this.containerPosition.isPassed) &&
        (!this.containerIsAccessible.isApplicable ||
          this.containerIsAccessible.isPassed) &&
        (!this.containerLocation.isApplicable ||
          this.containerLocation.isPassed) &&
        (!this.solonoidModel.isApplicable || this.solonoidModel.isPassed) &&
        (!this.gasTypeAndWeight.isApplicable ||
          this.gasTypeAndWeight.isPassed) &&
        (!this.pipingDiameterAndType.isApplicable ||
          this.pipingDiameterAndType.isPassed) &&
        (!this.detectorDetails.isApplicable || this.detectorDetails.isPassed) &&
        (!this.crosstab.isApplicable || this.crosstab.isPassed) &&
        (!this.shutdownButton.isApplicable || this.shutdownButton.isPassed) &&
        (!this.sealing.isApplicable || this.sealing.isPassed) &&
        (!this.powerOutages.isApplicable || this.powerOutages.isPassed) &&
        (!this.pressureClockIndicatesGreen.isApplicable ||
          this.pressureClockIndicatesGreen.isPassed) &&
        (!this.soloenoidConnected.isApplicable ||
          this.soloenoidConnected.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.containerPosition.getNotes(),
      ...this.containerIsAccessible.getNotes(),
      ...this.containerLocation.getNotes(),
      ...this.solonoidModel.getNotes(),
      ...this.gasTypeAndWeight.getNotes(),
      ...this.pipingDiameterAndType.getNotes(),
      ...this.detectorDetails.getNotes(),
      ...this.crosstab.getNotes(),
      ...this.shutdownButton.getNotes(),
      ...this.sealing.getNotes(),
      ...this.powerOutages.getNotes(),
      ...this.pressureClockIndicatesGreen.getNotes(),
      ...this.soloenoidConnected.getNotes()
    ];
  }
}
